<ng-container *ngIf="control" [formGroup]="control" [ngSwitch]="control.get(CONTROL_KEYS.type)?.value">
    <!--SEARCH FIELD-->
    <ng-container *ngSwitchCase="FILTER_TYPE.SEARCH">
        <div class="filter-input">
            <im2m-input [label]="control.get(CONTROL_KEYS.label)?.value | transloco" [suffix]="'search'" [formControlName]="CONTROL_KEYS.value"></im2m-input>
        </div>
    </ng-container>

    <!--SELECT BOX-->
    <ng-container *ngSwitchCase="FILTER_TYPE.SELECTION">
        <im2m-selection [label]="control.get(CONTROL_KEYS.label)?.value | transloco" [options]="control.get(CONTROL_KEYS.options)?.value || []" [formControlName]="CONTROL_KEYS.value"></im2m-selection>
    </ng-container>
    <!--DATE PICKER-->
    <ng-container *ngSwitchCase="FILTER_TYPE.DATE_PICKER">
        <im2m-date-picker [label]="control.get(CONTROL_KEYS.label)?.value | transloco" [formControlName]="CONTROL_KEYS.value"></im2m-date-picker>
    </ng-container>
</ng-container>
